import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  Dropdown,
  DropdownButton,
  Carousel,
  Spinner,
} from "react-bootstrap";
import TopHeader from "../../Components/TopHeader";
import MainHeader from "../../Components/MainHeader";
import Footer from "../../Components/Footer";
import "../../Pages/ProductsDetails/ProductsDetails.css";
import { FaCartPlus } from "react-icons/fa";
import AlertDialog from "../../Components/AlertDialog";

const ProductDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { car_id, maker_id, model_id } = location.state || {};
  const [products, setProducts] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Scroll to the top whenever this component is loaded
    window.scrollTo(0, 0);

    console.log(location.state);
    setProducts(location.state.data);
  }, [location.state]); // This ensures that the effect runs when location.state changes
  
  const handleSelectPlan = (productId, selectedPlan) => {
    const planData = products
      .find((product) => product.id === productId)
      ?.prices.find((plan) => plan.id === parseInt(selectedPlan));

    setSelectedPlans((prev) => ({
      ...prev,
      [productId]: planData || null,
    }));

    console.log("Selected Plan for product ID:", productId, planData);
  };

  const addToCartAndNavigate = (model) => {
    console.log(model);
    const selectedPlan = selectedPlans[model.id] || null; // Get selected plan
  
    const selectedCarData = {
      id: model.id,
      images: model.images,
      videos: model.videos,
      prices: model.prices,
      plan: selectedPlan, // Attach selected plan
      quantity: 1,
      productCode: model.product_code,
      productDescription: model.product_desc,
      ShortDesc: model.short_des,
      headTitle: model.head_title,
      engineCapacity: model.engine_capacity || "N/A",
      modelName: model.models?.model_name || "N/A", // Use optional chaining here
      title: model.descriptions?.[0]?.d_title || "N/A",
      feature: model.descriptions?.[0]?.d_feature || "N/A",
      carType: model.car_type || "N/A",
      serviceType: model.service_type || "N/A",
    };
  
    console.log("Car data sent to ProductSingle", selectedCarData);
    console.log(
      "data desssssss",
      selectedCarData.title,
      selectedCarData.feature
    );
  
    // Show alert first with shorter timeout
    AlertDialog(
      "Selected",
      `${model.models?.model_name || "Car"}`, // Use optional chaining here as well
      "success",
      800, // Shorter timer for quicker navigation
      false,
      false,
      "",
      "",
      // Empty callback - we'll navigate directly after this
      null,
      null
    );
  
    // Navigate directly after a slight delay to ensure alert is seen
    setTimeout(() => {
      navigate("/Product-single", {
        state: { selectedCars: [selectedCarData] },
      });
    }, 900); // Set timeout slightly longer than the alert timer
  };
  

  console.log(products);
  return (
    <div>
      <TopHeader />
      <MainHeader />
      <Container className="mt-4 product_details_main">
        {!loading ? (
          <Spinner animation="border" role="status" className="d-block mx-auto">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : products ? (
          <>
            <Row className="mb-4">
              <Col>
                <h1>Car Details</h1>
              </Col>
            </Row>
            <Row>
              {products.map((model) => (
                <Col lg={4} md={6} sm={12} key={model.id} className="mb-4">
                  <Card className="image-card shadow h-100">
                    <Carousel
                      className="image-card-carousel"
                      interval={null}
                      style={{ height: "250px" }}
                    >
                      {model.images.map((img, idx) => (
                        <Carousel.Item key={`img-${idx}`}>
                          <img
                            src={`https://motor-easy.clickbooster.io/assets/entryimages/${img.image}`}
                            alt={`Model ${model.model_name} ${idx}`}
                            className="d-block w-100 h-100 carousel__image"
                            style={{
                              height: "250px !important",
                              objectFit: "cover !important",
                            }}
                          />
                        </Carousel.Item>
                      ))}
                      {model.videos.map((vid, idx) => (
                        <Carousel.Item key={`vid-${idx}`}>
                          <video
                            className="d-block w-100 h-100"
                            controls
                            src={`https://motor-easy.clickbooster.io/assets/entryvideos/${vid.video}`}
                          >
                            Your browser does not support the video tag.
                          </video>
                        </Carousel.Item>
                      ))}
                    </Carousel>
                    <Card.Body className="pb-0">
                      <Card.Title>
                        <div className="text-start mb-3">
                          <h4 className="fw-bold text-primary mb-1 d-inline-block">
                            {model.head_title || "Details not available"}
                            <span className="text-muted"> - </span>
                            {model.models?.model_name ||
                              "Details are not available"}
                          </h4>
                          <h5 className="fw-light text-secondary d-inline-block ms-2">
                            {model.prices?.[0]?.price || "NA"}
                          </h5>
                        </div>

                        <div className="mt-2">
                          <p className="fw-light fs-6">
                            {model.product_desc || "N/A"}
                          </p>
                        </div>
                      </Card.Title>
                      <hr className="bg-secondary" />
                      <Card.Text className="px-0">
                        <div className="text-start">
                          <ul className="list-unstyled p-0">
                            <li>
                              <strong>Car Type:</strong>{" "}
                              {model.car_type || "N/A"}
                            </li>
                            <li>
                              <strong>Engine Capacity:</strong>{" "}
                              {model.engine_capacity || "N/A"}
                            </li>
                            <li>
                              <strong>Service Type:</strong>{" "}
                              {model.service_type || "N/A"}
                            </li>
                            <li>
                              <strong>Product Code:</strong>{" "}
                              {model.product_code || "N/A"}
                            </li>
                          </ul>
                        </div>
                      </Card.Text>
                      <hr className="bg-secondary" />
                    </Card.Body>

                    {/* 🔥 Price Selection Dropdown & View Details Button */}
                    <Card.Footer className="d-flex  justify-content-end align-items-center px-3 border-0">
                      <button
                        className="btn btn-info mx-3 fw-bold w-sm-auto btn-lg btn-md btn-sm py-2"
                        onClick={() => addToCartAndNavigate(model)}
                      >
                        <FaCartPlus className="me-1" />
                        View Details
                      </button>

                      {/* <div className=""> */}
                      {/*     <DropdownButton */}
                      {/*         id={`dropdown-${model.id}`} */}
                      {/*         className="w-100 w-sm-auto px-3 py-2 mx-0 my-2" */}
                      {/*         title={ */}
                      {/*             selectedPlans[model.id] */}
                      {/*                 ? `${selectedPlans[model.id].plan_name} - ${selectedPlans[model.id].plan_duration */}
                      {/*                 } - $${selectedPlans[model.id].price}` */}
                      {/*                 : model.prices && model.prices.length > 0 */}
                      {/*                     ? `${model.prices[0].plan_name || "Plan Name" */}
                      {/*                     } - ${model.prices[0].plan_duration || "Duration" */}
                      {/*                     } - $${model.prices[0].price || "Price"}` */}
                      {/*                     : "Select a Plan" */}
                      {/*         } */}
                      {/*         onSelect={(selectedPlanId) => { */}
                      {/*             handleSelectPlan(model.id, selectedPlanId); */}
                      {/*         }} */}
                      {/*     > */}
                      {/*         {model.prices && */}
                      {/*             model.prices.map((plan, index) => ( */}
                      {/*                 <Dropdown.Item */}
                      {/*                     key={`${plan.id}-${index}`} */}
                      {/*                     eventKey={plan.id.toString()} */}
                      {/*                 > */}
                      {/*                     {`${plan.plan_name || "Plan Name"} - ${plan.plan_duration || "Duration" */}
                      {/*                         } - $${plan.price || "Price"}`} */}
                      {/*                 </Dropdown.Item> */}
                      {/*             ))} */}
                      {/*     </DropdownButton> */}
                      {/* </div> */}
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        ) : (
          <Alert variant="danger">{error || "No car details available."}</Alert>
        )}
      </Container>
      <Footer />
    </div>
  );
};

export default ProductDetails;